import React from 'react'

import WelcomeMutualFund from './WelcomeMutualFund/WelcomeMutualFund';
import ProductWhymutualFund from './ProductWhyMutualFund/ProductWhymutualFund';
import ProductMutualFundFAQ from './ProductMutualFundFAQ/ProductMutualFundFAQ';
import ExploreMutualFund from './ExploreMutualFund/ExploreMutualFund';


function ProductMutualFund() {
    return (
        <>
            <WelcomeMutualFund />
            <ProductWhymutualFund />
            <ExploreMutualFund/>
            <ProductMutualFundFAQ />

        </>
    )
}
export default ProductMutualFund;
